import React, { useState } from "react";
import { useTheme } from "../context/ThemeContext";

type Row = {
  codigo: string;
  nomeProduto: string;
  quantidadeEstoque: number;
  quantidadeSelecionada: number;
};

type TableProps = {
  headers: (keyof Row)[];
  rows: Row[];
  onUpdateRows: (updated: Row[]) => void;
  columnWidths?: string[];
};

const MovementTable: React.FC<TableProps> = ({
  headers,
  rows,
  onUpdateRows,
  columnWidths,
}) => {
  const [filters, setFilters] = useState<string[]>(
    Array(headers.length).fill("")
  );
  const [selectedRow, setSelectedRow] = useState<number | null>(null);

  const handleFilterChange = (index: number, value: string) => {
    const newFilters = [...filters];
    newFilters[index] = value.toUpperCase(); // sempre maiúsculo
    setFilters(newFilters);
    setSelectedRow(null);
  };

  const handleQuantityChange = (index: number, operation: "+" | "-") => {
    const newRows = [...rows];
    const currentQuantity = newRows[index].quantidadeSelecionada;

    if (
      operation === "+" &&
      currentQuantity < newRows[index].quantidadeEstoque
    ) {
      newRows[index].quantidadeSelecionada = currentQuantity + 1;
    } else if (operation === "-" && currentQuantity > 0) {
      newRows[index].quantidadeSelecionada = currentQuantity - 1;
    }

    if (newRows[index].quantidadeSelecionada === 0) {
      newRows.splice(index, 1);
    }

    onUpdateRows(newRows);
  };
  const { theme } = useTheme();
  const primaryColor = theme?.primary || "#124280";
  const filteredRows = rows.filter((row) =>
    headers.every((key, i) => {
      const cellValue = row[key]?.toString().toUpperCase() || "";
      return cellValue.includes(filters[i]);
    })
  );

  const getColumnStyle = (index: number): React.CSSProperties => ({
    width: columnWidths?.[index] || "auto",
    maxWidth: columnWidths?.[index] || "auto",
  });

  return (
    <div
      style={{
        marginLeft: "0px",
        marginRight: "0px",
        marginTop: "36px",
        fontFamily: "Inter, sans-serif",
      }}
    >
      <table
        style={{
          borderCollapse: "collapse",
          width: "100%",
          tableLayout: "fixed",
        }}
      >
        <thead>
          <tr>
            {headers.map((header, index) => (
              <th
                key={index}
                style={{
                  ...getColumnStyle(index),
                  backgroundColor: primaryColor,
                  color: "#ffffff",
                  fontWeight: 300,
                  fontSize: "14px",
                  height: "40px",
                  padding: "0 8px",
                  border: "1px solid black",
                  textAlign: "center",
                }}
              >
                {header === "quantidadeEstoque"
                  ? "Q. Atual"
                  : header === "quantidadeSelecionada"
                  ? "Q. Selecionada"
                  : header === "nomeProduto"
                  ? "Nome do Produto"
                  : header === "codigo"
                  ? "Código do Produto"
                  : header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            {headers.map((_, index) => (
              <td
                key={`filter-${index}`}
                style={{
                  ...getColumnStyle(index),
                  height: "35px",
                  border: "1px solid black",
                  padding: "0 8px",
                }}
              >
                <input
                  type="text"
                  value={filters[index]}
                  onChange={(e) =>
                    handleFilterChange(index, e.target.value.toUpperCase())
                  }
                  style={{
                    width: "100%",
                    height: "30px",
                    border: "none",
                    outline: "none",
                    fontSize: "13px",
                    fontWeight: 300,
                    fontFamily: "Inter, sans-serif",
                    padding: "0 4px",
                    boxSizing: "border-box",
                    textAlign: "center",
                  }}
                />
              </td>
            ))}
          </tr>

          {filteredRows.map((linha, rowIndex) => (
            <tr
              key={rowIndex}
              onClick={() => setSelectedRow(rowIndex)}
              style={{
                backgroundColor:
                  selectedRow === rowIndex
                    ? "rgba(18, 66, 128, 0.2)"
                    : "#ffffff",
                cursor: "pointer",
              }}
            >
              {headers.map((header, colIndex) => (
                <td
                  key={colIndex}
                  style={{
                    ...getColumnStyle(colIndex),
                    height: "35px",
                    padding: "0 8px",
                    border: "1px solid black",
                    color: "#000000",
                    fontSize: "15px",
                    fontWeight: 300,
                    textAlign: "center",
                    verticalAlign: "middle",
                    fontFamily: "Inter, sans-serif",
                  }}
                >
                  {header === "quantidadeSelecionada" ? (
                    <>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleQuantityChange(rowIndex, "-");
                        }}
                        style={{
                          fontSize: "18px",
                          padding: "2px 10px",
                          marginRight: "8px",
                          backgroundColor: "transparent",
                          border: "none",
                          cursor: "pointer",
                        }}
                      >
                        -
                      </button>
                      {linha[header]}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleQuantityChange(rowIndex, "+");
                        }}
                        style={{
                          fontSize: "18px",
                          padding: "2px 10px",
                          marginLeft: "0px",
                          backgroundColor: "transparent",
                          border: "none",
                          cursor: "pointer",
                        }}
                      >
                        +
                      </button>
                    </>
                  ) : (
                    linha[header]
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MovementTable;
